<template>
  <section class="landing-page-cover">
    <v-parallax
      :src="parallaxURL"
      :height="parallaxHeight"
      :class="{ dark: section.dark, 'default-height': !hasCustomHeight }"
    >
      <v-row no-gutters align="center" justify="center">
        <v-col class="text-center" cols="12">
          <v-img
            v-if="section.logoSrc"
            class="mb-10"
            contain
            max-height="256"
            :src="logoURL"
            alt="Logotipo do Programa"
          ></v-img>

          <h1
            v-if="section.title"
            class="display-2 font-weight-black mb-12"
            v-html="$sanitize(section.title)"
          ></h1>

          <div
            v-if="section.secondText"
            class="subheading font-weight-light mb-3"
            v-html="$sanitize(section.secondText)"
            v-text="section.secondText"
          ></div>

          <div
            v-if="section.thirdText"
            class="display-1 font-weight-thin mb-12"
            v-html="$sanitize(section.thirdText)"
          ></div>

          <v-btn
            v-if="section.loginButton.title"
            class="pa-6 font-weight-regular"
            rounded
            color="success"
            :to="{ path: preview ? '' : section.loginButton.path }"
          >{{ section.loginButton.title }}</v-btn>
        </v-col>
      </v-row>
    </v-parallax>
  </section>
</template>

<script>
import TipoSecaoEnum from "~/commons/enums/tipo-secao.enum";

export function CoverLoginButton(
  options = { title: "Quero Acessar", path: "/app" }
) {
  this.title = options.titulo || options.title;
  this.path = options.endereco || options.path;

  this.isValid = function () {
    return this.title
      ? typeof this.path === "string" && this.path.length > 0
      : true;
  };

  this.stringify = function () {
    return JSON.stringify({ ...this });
  };

  this.toApi = function () {
    return {
      titulo: this.title,
      endereco: this.path,
    };
  };

  if (!this.isValid()) {
    throw new Error("Botão de Login da seção de Capa inválido.");
  }
}

export function Cover(
  options = {
    title: "Título",
    secondText: `Informação`,
    thirdText: `Descrição`,
    coverSrc: null,
    logoSrc: null,
    menuTitle: undefined,
    dark: true,
    height: undefined,
  }
) {
  Object.defineProperty(this, "type", { get: () => TipoSecaoEnum.CAPA });
  this.height = options.altura || options.height;
  this.dark = typeof options.escuro !== "undefined" ? options.escuro : options.dark;
  this.menuTitle = options.menu || options.menuTitle;
  this.coverSrc = options.enderecoDaImagem || options.coverSrc;
  this.logoSrc = options.enderecoDaImagemDoLogotipo || options.logoSrc;
  this.title = options.titulo || options.title;
  this.secondText = options.segundoTexto || options.secondText;
  this.thirdText = options.terceiroTexto || options.thirdText;
  this.loginButton =
    options.acesso || options.loginButton
      ? new CoverLoginButton(options.acesso || options.loginButton)
      : new CoverLoginButton();

  this.isValid = function () {
    return this.coverSrc && this.loginButton.isValid();
  };

  this.stringify = function () {
    return JSON.stringify({ ...this, type: TipoSecaoEnum.CAPA });
  };

  this.toApi = function () {
    return {
      altura: this.height,
      escuro: this.dark,
      menu: this.menuTitle,
      coverSrc: this.coverSrc,
      logoSrc: this.logoSrc,
      titulo: this.title,
      segundoTexto: this.secondText,
      terceiroTexto: this.thirdText,
      acesso: this.loginButton.toApi(),
      tipo: TipoSecaoEnum.CAPA,
      indicadorSecao: TipoSecaoEnum.CAPA
    };
  };
}

export default {
  name: "LandingPageCover",
  props: {
    preview: {
      type: Boolean,
      required: false,
    },
    section: {
      type: Cover,
      required: true,
      validator(value) {
        return value.isValid();
      },
    },
  },
  data: () => ({
    windowHeight: undefined,
  }),
  mounted() {
    if (isNaN(parseInt(this.section.height))) {
      window.addEventListener("resize", this.onResizeWindow);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.aoRedimensionarJanelav);
  },
  computed: {
    parallaxURL() {
      return URL.createObjectURL(this.section.coverSrc || new File([""], "cover.png", { type: "image/png" }))
    },
    logoURL() {
      return URL.createObjectURL(this.section.logoSrc || new File([""], "logo.png", { type: "image/png" }))
    },
    parallaxHeight() {
      return this.hasCustomHeight
        ? this.section.height
        : this.windowHeight || window.innerHeight;
    },
    hasCustomHeight() {
      return (
        !isNaN(parseInt(this.section.height)) &&
        parseInt(this.section.height) !== 0
      );
    },
  },
  methods: {
    onResizeWindow() {
      this.windowHeight = window.innerHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-parallax){
  max-width: 100vw;

  &.default-height {
    min-height: calc(100vh + 12px);
  }

  &.dark {
    .v-parallax__image-container {
      filter: brightness(50%);
    }
  }
}
</style>
